import { Link, useInRouterContext } from "react-router";
import { useI18n } from "@wato/i18n/react";
import { useHelpLink } from "./useHelpLink";

/**
 * W22: small "Step-by-step guide" link from an error or empty state to its Help Center article
 * (`/w/:workspaceId/help-center/<slug>`). Renders nothing outside the workspace shell.
 */
export function HelpArticleLink({
  slug,
  className = "text-sm font-medium text-on-action-ghost underline",
}: {
  readonly slug: string;
  readonly className?: string;
}) {
  const { t } = useI18n();
  const inRouter = useInRouterContext();
  const { helpHref } = useHelpLink(slug);
  if (!helpHref) return null;
  const label = t("dashboard.helpCenter.guideLink");
  return inRouter ? (
    <Link to={helpHref} data-help-slug={slug} className={className}>
      {label}
    </Link>
  ) : (
    <a href={helpHref} data-help-slug={slug} className={className}>
      {label}
    </a>
  );
}
